// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__151Km","topBottomGutter":"Layout_topBottomGutter__3Gz_F"};